<script>
  import { onMount } from 'svelte';
  import MainScreen from './MainScreen.svelte';
  import { fade } from 'svelte/transition';
  import AdminPanel from './AdminPanel.svelte';
  let loading = true;
  export let isTelegramEnv;
  export let authData;
  let isAdminView = true;
  onMount(() => {
    setTimeout(() => {
      loading = false;
    }, 2800);
    try {
      // Простая проверка, что authData передан
      if (!authData) {
        error = "Admin authentication data not provided. Cannot load admin panel.";
        return;
      }

      // Создаем и настраиваем XMLHttpRequest для синхронного запроса
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/myapi/auth', false); // false делает запрос синхронным
      xhr.setRequestHeader('Content-Type', 'application/json');

      const decodedData = decodeURIComponent(authData);
      const userPart = decodedData.split('user=')[1].split('&')[0];
      const userData = JSON.parse(userPart);
      const userId = userData.id;
      
      // Отправляем запрос на проверку прав администратора
      xhr.send(JSON.stringify({ user_id: userId }));

      // Проверяем статус ответа
      if (xhr.status !== 200) {
        throw new Error(`HTTP error! status: ${xhr.status}`);
      }

      const result = JSON.parse(xhr.responseText);
      
      if (result.status !== "success") {
        throw new Error("Invalid response from server");
      }

      // Устанавливаем флаг аутентификации администратора
      isAdminView = result.is_admin;
      

    } catch (err) {
      isAdminView = false;
    }
  });
</script>

{#if isAdminView}
  <AdminPanel {authData} {isAdminView} />
{:else if loading}
  <div class="loading-screen">
    <div class="stars-background">
      <div class="stars stars1"></div>
      <div class="stars stars2"></div>
      <div class="stars stars3"></div>
    </div>

    <div class="logo-container" transition:fade={{ duration: 500 }}>
      <div class="stars-logo">
         <div class="css-star loading-star"></div>
        <span class="stars-text">Stars Рулетка</span>
      </div>
      <div class="slogan">Выигрывай звёзды в премиум-рулетке</div>
    </div>

    <div class="loading-bar-container" transition:fade={{ delay: 300, duration: 400 }}>
      <div class="loading-bar"></div>
    </div>
  </div>
{:else}
  <div class="app-wrapper" transition:fade={{ duration: 400 }}>
     <MainScreen {isTelegramEnv} {authData} />
  </div>
{/if}

<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');

  :global(body) {
    margin: 0;
    padding: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    color: #E1E9F0; 
    height: 100vh;
    overflow: hidden;
  }

  .app-wrapper {
      height: 100%;
  }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: radial-gradient(ellipse at bottom, #1B2735 0%, #090A0F 100%);
    position: relative;
    overflow: hidden; 
    z-index: 1;
  }

  .stars-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1; 
  }

  .stars {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
    background: transparent; 
    background-repeat: repeat;
    background-size: cover; 
    animation: moveStars 150s linear infinite alternate;
  }

 .stars1 {
    background-image: radial-gradient(1px 1px at 20px 30px, #CCCCCC, rgba(0,0,0,0)),
                      radial-gradient(1px 1px at 40px 70px, #FFFFFF, rgba(0,0,0,0)),
                      radial-gradient(1px 1px at 50px 160px, #DDDDDD, rgba(0,0,0,0)),
                      radial-gradient(2px 2px at 90px 40px, #FFFFFF, rgba(0,0,0,0)),
                      radial-gradient(1px 1px at 130px 80px, #CCCCCC, rgba(0,0,0,0)),
                      radial-gradient(1px 1px at 160px 120px, #DDDDDD, rgba(0,0,0,0));
    background-size: 200px 200px;
    animation-duration: 100s;
    opacity: 0.6;
  }

  .stars2 {
     background-image: radial-gradient(1px 1px at 10px 50px, #CCCCCC, rgba(0,0,0,0)),
                       radial-gradient(1px 1px at 60px 90px, #FFFFFF, rgba(0,0,0,0)),
                       radial-gradient(2px 2px at 100px 150px, #DDDDDD, rgba(0,0,0,0)),
                       radial-gradient(1px 1px at 140px 30px, #FFFFFF, rgba(0,0,0,0)),
                       radial-gradient(1px 1px at 180px 100px, #CCCCCC, rgba(0,0,0,0));
     background-size: 250px 250px;
     animation-duration: 150s;
     opacity: 0.7;
  }

  .stars3 {
      background-image: radial-gradient(2px 2px at 5px 5px, #FFFFFF, rgba(0,0,0,0)),
                       radial-gradient(1px 1px at 80px 40px, #DDDDDD, rgba(0,0,0,0)),
                       radial-gradient(1px 1px at 120px 180px, #CCCCCC, rgba(0,0,0,0)),
                       radial-gradient(1px 1px at 170px 60px, #FFFFFF, rgba(0,0,0,0));
     background-size: 300px 300px;
     animation-duration: 200s;
     opacity: 0.5;
  }

  @keyframes moveStars {
    from { transform: translate(0, 0); }
    to { transform: translate(-100px, -100px); } 
  }

  .logo-container {
    z-index: 2;
    text-align: center;
  }

  .stars-logo {
    font-size: 2.4rem;
    font-weight: 700;
    margin-bottom: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .css-star {
    width: 3rem; 
    height: 3rem;
    position: relative;
    display: inline-block;
    --star-color: #6EBFFF; 
    --star-shadow: rgba(110, 191, 255, 0.6);
    animation: loadingStarPulse 2s infinite ease-in-out;
  }
  .css-star::before,
  .css-star::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--star-color);
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    filter: drop-shadow(0 0 8px var(--star-shadow));
  }
  .css-star::after {
     transform: rotate(15deg) scale(0.8); 
     opacity: 0.6;
     filter: drop-shadow(0 0 12px var(--star-shadow));
     animation: loadingStarRotate 8s linear infinite;
  }

  @keyframes loadingStarPulse {
    0%, 100% { transform: scale(0.95); opacity: 0.9; }
    50% { transform: scale(1.05); opacity: 1; }
  }
  @keyframes loadingStarRotate {
    from { transform: rotate(15deg) scale(0.8); }
    to { transform: rotate(375deg) scale(0.8); }
  }

  .stars-text {
    background: linear-gradient(90deg, #87C3FF, #B4DFFF); 
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 12px rgba(135, 195, 255, 0.5);
  }

  .slogan {
    font-size: 0.95rem;
    color: #A6C5E1; 
    margin-bottom: 2.5rem;
    opacity: 0.9;
  }

  .loading-bar-container {
    width: 70%;
    max-width: 280px;
    height: 6px;
    background-color: rgba(110, 191, 255, 0.15);
    border-radius: 3px;
    overflow: hidden;
    z-index: 2;
    box-shadow: 0 0 10px rgba(110, 191, 255, 0.1);
  }

  .loading-bar {
    height: 100%;
    width: 0;
    background: linear-gradient(to right, #6EBFFF, #A6D9FF);
    border-radius: 3px;
    animation: loading 2.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards; 
    box-shadow: 0 0 8px rgba(110, 191, 255, 0.6);
  }

  @keyframes loading {
    0% { width: 0%; }
    100% { width: 100%; }
  }

</style>